import initShell from './shell';
import { onFetchPackagesOnStartComplete, getFetchPackagesList, packageNameToUrlResolver } from './utils';

const initSliqbrbShell = ({
    packageManifestEndpoint,
    onFetchPackagesOnStartCompleteHandler,
    onFetchPackagesOnCompleteHandler,
    fetchPackagesOnStartList = [],
    fetchPackagesOnCompleteList = []
}) => {
    let packageConfigMap;
    const onPackageManifestFetchComplete = response => {
        packageConfigMap = response.launchpadPackageConfig;
    };

    const getFetchPackagesOnStartList = () => {
        const list = [
            'platform-vendor-ui',
            'app-container-ui',
            'async-common-components',
            'navigation-common-components',
            'platform-asio-theme-service',
            'platform-common-form',
            'platform-net-service',
            'platform-entity-service',
            'platform-common-service',
            'platform-common-utils',
            'platform-i18n-utils',
            'platform-user-auth-service',
            'sli-qbrb-common-service',
            'sli-qbrb-module'
        ];

        return list.concat(getFetchPackagesList(packageConfigMap, fetchPackagesOnStartList));
    };

    initShell({
        requestHeaders: {},
        fetchPackagesOnStart: () => getFetchPackagesList(packageConfigMap, getFetchPackagesOnStartList()),
        fetchPackagesOnComplete: () => getFetchPackagesList(packageConfigMap, fetchPackagesOnCompleteList),
        onPackageManifestFetchComplete,
        onFetchPackagesOnStartComplete: onFetchPackagesOnStartComplete(
            onFetchPackagesOnStartCompleteHandler,
            onFetchPackagesOnCompleteHandler
        ),
        onFetchPackagesOnCompleteHandler,
        packageManifestEndpoint:
            packageManifestEndpoint || `${window.RMM.integrationDomain}/GraphQL/configuration`,
        packageNameToUrlResolver: packageName => packageNameToUrlResolver(packageConfigMap, packageName)
    });
};

export default initSliqbrbShell;
